import styled from 'styled-components';

export const PaypalContainer = styled.div`
    background-color: white;
    border-radius: 5px;
    border: 1px solid rgb(198, 198, 198);
    box-shadow: rgba(198, 198, 198, 0.282) 0px 0px 0px;
    padding: 20px;
    cursor: pointer;
    transition: all 200ms ease 0s;

    .paypal-head {
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        flex-direction: row;
        align-items: center;

        .paypal-head-text {
            text-align: right;
            p {
                font-size: 10px;
            }
        }
    }

    .paypal-text {
        font-size: 13px;
        font-style: italic;
    }

    @media (max-width: ${props => props.theme.medium}) {
        flex-direction: column;
        align-items: flex-start;

        .paypal-head-text {
            text-align: left;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/funnel/payment-selection-step/payment-choice/PaypalStyle.js